import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from '@/router';
import store from './store/index.js';
import axios from 'axios';
import qs from 'qs';

Vue.use(ElementUI);

Vue.config.productionTip = true;
Vue.use(Vuex);
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
import glocal from '@/css/reset.css'

new Vue({
  render: h => h(App),
  router,
  store,
  axios,
  qs
}).$mount('#app')
